import { type FunctionComponent, useEffect } from 'react';
import { ScrollRestoration, useLocation } from 'react-router-dom';

export type SetScrollProps = {};

export const SetScroll: FunctionComponent<SetScrollProps> = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return <ScrollRestoration />;
};
